import { createRouter, createWebHistory } from 'vue-router'


import Vue from '../main'
const router = createRouter({
    history: createWebHistory(),
    routes: [
        { path: '', redirect: '/home' },
        { path: '/Test', component: () => import('../page/PageTest.vue')},
        { path: '/home', component: () => import('../page/Home.vue')},
        { path: '/BlogIndex', component: () => import('../page/BlogIndex.vue')},
        { path: '/getNote/:id', component: () => import('../page/NoteView.vue'), props: true },
        { path: '/Archives', component: () => import('../page/PageArchives.vue'),props: true },
        { path: '/Archives/:archiveName', component: () => import('../page/PageArchives.vue'),props: true },
        { path: '/Introduction', component: () => import('../page/PageIntroductionVol2.vue')},
        { path: '/IntroductionOld', component: () => import('../page/PageIntroduction.vue')},
        { path: '/BackManagerLogin', component: () => import('../page/BackManagerLogin.vue')},
        { path: '/BackManager', component: () => import('../page/BackManager.vue')},
        
    ]
})
// eslint-disable-next-line
router.beforeEach((to, from,next) => {
    if (to.path=="/BackManagerLogin") {
        if (Vue.$cookies.get('accessCode')) {
            next({ path: '/BackManager' })
        }else{
            next()
        }
    }else if (to.path=="/BackManager") {
        if (Vue.$cookies.get('accessCode')) {
            next()
        }else{
            next({ path: '/BackManagerLogin' })
        }
    }else{
        next()
    }
})
export default router